<template>
  <div class="form-group">
    <input
      type="text"
      name="qaTitle"
      class="form-control form-control-lg rounded-0"
      id="qa-title"
      required
      :placeholder="'请用一句话说明您的问题'"
      maxlength="64"
      v-model="qaTitle"
      @input="handleInputQaTitle"
    />
    <!-- <p v-show="isQaTitleBlank" class="text-danger">请输入标题</p> -->
    <p v-show="c_isQaTitleToolong" class="text-danger">
      {{ '标题不能超过64个有效字符' }}
    </p>
  </div>
</template>
<script>
import { QaTitleModelMixin } from '@/mixins/QA/Title/model';

export default {
  name: 'qa-title',

  mixins: [QaTitleModelMixin],

  props: {
    value: {
      type: String,
      default: () => '',
    },
  },

  methods: {
    handleInputQaTitle() {
      this.$emit('input', this.qaTitle);
    },
  },
};
</script>
<style lang="scss" scoped></style>
